import { cacaClient } from '@plangrid-private/web-api-clients';
import useSWR from 'swr';

import { useCurrentProjectId } from '@adsk/alloy-provider';

import { FORMS_SWR_CONFIG, FEATURE_FLAGS } from '../helpers/constants';
import { getForgeUserMappingUrl } from '../helpers/utils';
import { usePlangridFeatureFlag } from '../PlangridLaunchDarklyProvider';

export default () => {
  const projectId = useCurrentProjectId();
  const { value: isRemovedMemberFormatOn } = usePlangridFeatureFlag(
    FEATURE_FLAGS.FORMS_REMOVED_MEMBER,
    false,
  );
  const { data, error } = useSWR(
    [getForgeUserMappingUrl(projectId), isRemovedMemberFormatOn],
    async () => {
      const mapping = await cacaClient.users.getForgeMapping(projectId, {
        include_removed: isRemovedMemberFormatOn,
      });
      return mapping;
    },
    FORMS_SWR_CONFIG,
  );

  return {
    data,
    isError: error,
    isLoading: !error && !data,
  };
};
